import { makeUUID } from "@core/services/orm/idGenerator";

const SESSION_STORAGE_KEY_PREFIX = 'archipad.sync.session.';

/**
 * A sync session groups everything that happens to a project between two syncs (`archipad.sync.session_id` log attribute),
 * to be able to trace what happened to local changes that have been lost.
 *
 * The session is persisted in the localStorage so it survives a reload (e.g. the tab discarded while the device sleeps).
 */
export class SyncSessionService {
    /**
     * Returns the current sync session of a project, creates it if needed.
     */
    public getSessionId(projectId: string): string {
        const storageKey = SESSION_STORAGE_KEY_PREFIX + projectId;
        try {
            let sessionId = localStorage.getItem(storageKey);
            if (!sessionId) {
                sessionId = makeUUID();
                localStorage.setItem(storageKey, sessionId);
            }
            return sessionId;
        } catch {
            return 'unavailable'; // no localStorage (service worker, private mode)
        }
    }

    /**
     * Starts a new sync session for a project, to call once its local changes have been published or discarded.
     *
     * @returns the previous session id
     */
    public startNewSession(projectId: string): string {
        const previousSessionId = this.getSessionId(projectId);
        try {
            localStorage.setItem(SESSION_STORAGE_KEY_PREFIX + projectId, makeUUID());
        } catch {
            // no localStorage, keep the previous session
        }
        return previousSessionId;
    }
}

const syncSessionService = new SyncSessionService();
export default syncSessionService;
